const DEFAULT_VALUES = {
  fineAmount: 0,
  licencePoints: 0,
  drivingBanPeriod: 0,
};

const getResultByConviction = (value) => {
  switch (value) {
    case "NONE":
      return {
        fineAmount: 500,
        licencePoints: 2,
        drivingBanPeriod: 1,
      };
    case "ONE":
      return {
        fineAmount: 1000,
        licencePoints: 2,
        drivingBanPeriod: 3,
      };
    case "TWO":
    case "MORE_THAN_TWO":
      return {
        fineAmount: 1500,
        licencePoints: 2,
        drivingBanPeriod: 3,
      };
    default:
      return DEFAULT_VALUES;
  }
};

const calculate = (data) => {
  if (data.TYPE === "ALCOHOL") {
    if (data.MEASUREMENT_TYPE === "BREATH") {
      switch (data.AMOUNT_OF_ALCOHOL_BREATH) {
        case "MEDIUM":
          return getResultByConviction(data.CONVICTIONS_ALCOHOL_BREATH);
        case "LARGE":
          return {
            fineAmount: "Variabel",
            licencePoints: 3,
            drivingBanPeriod: Number.POSITIVE_INFINITY,
          };
        default:
          return DEFAULT_VALUES;
      }
    }

    if (data.MEASUREMENT_TYPE === "BLOOD") {
      switch (data.AMOUNT_OF_ALCOHOL_BLOOD) {
        case "MEDIUM":
          return getResultByConviction(data.CONVICTIONS_ALCOHOL_BLOOD);
        case "LARGE":
          return {
            fineAmount: "Variabel",
            licencePoints: 3,
            drivingBanPeriod: Number.POSITIVE_INFINITY,
          };
        default:
          return DEFAULT_VALUES;
      }
    }
  }

  if (data.TYPE === "DRUGS") {
    return getResultByConviction(data.CONVICTIONS_AMOUNT_DRUGS);
  }

  return DEFAULT_VALUES;
};

export default calculate;
